import { apiClient } from './api'

export interface YardAssignment {
  userId: string
  assignedYards: string[]
  yardPermissions: 'all' | 'assigned'
}

export interface UpdateYardAssignmentRequest {
  assignedYards?: string[]
  yardPermissions?: 'all' | 'assigned'
}

/**
 * Get user's yard assignments
 */
export const getUserYardAssignments = async (userId: string): Promise<YardAssignment> => {
  const response = await apiClient.get(`/users/${userId}/yard-assignments`)
  return response.data
}

/**
 * Update user's yard assignments
 */
export const updateUserYardAssignments = async (
  userId: string,
  data: UpdateYardAssignmentRequest
): Promise<{ message: string; user: any }> => {
  const response = await apiClient.put(`/users/${userId}/yard-assignments`, data)
  return response.data
}
